module.exports = __webpack_public_path__ + "static/media/family.45966480.png";